import { packagingApi } from '../../api/vendor/packagingApi.ts';
import { vendorApi } from './vendorService.ts';
import type { PackageDraft, PackageSourceInput } from '../../api/vendor/packagingApi.ts';
import type { PagedRequest } from '../../types/common/common.ts';
import type { CreateVendorPackageInput } from '../../types/vendor/vendor.types.ts';

export { packagingError } from '../../api/vendor/packagingApi.ts';
export const vendorPackagingService = {
  identity: async (userName: string) => (await vendorApi.getVendorId(userName)).data,
  vendors: async () => structuredClone(await packagingApi.vendors()),
  products: async (vendorId: string) => structuredClone(await packagingApi.products(vendorId)),
  search: async (params: PagedRequest) => structuredClone(await packagingApi.search(params)),
  detail: async (id: string, poPage: number, lotPage: number) => structuredClone(await packagingApi.detail(id, poPage, lotPage)),
  duplicate: async (vendorId: string, productId: string, lot: string) => packagingApi.duplicate(vendorId, productId, lot),
  sourceInfo: async (vendorId: string, productId: string, lots: string[]) => structuredClone(await packagingApi.sourceInfo(vendorId, productId, lots)),
  create: async (draft: PackageDraft) => structuredClone(await packagingApi.create(draft)),
  append: async (id: string, request: { poNumber?: string; sourceLot?: PackageSourceInput }) => { await packagingApi.append(id, request); },
  legacyList: async (vendorId: string, params: PagedRequest) => structuredClone((await vendorApi.getPackagingList(vendorId, params)).data),
  legacyDetail: async (id: string) => {
    const slip = structuredClone((await vendorApi.getPackagingDetail(id)).data);
    const lots = slip?.oid ? structuredClone((await vendorApi.getPackagingVendorLots(slip.oid)).data) : [];
    return { slip, lots };
  },
  legacyCreate: async (dto: CreateVendorPackageInput) => { await vendorApi.createPackaging(dto); },
};